module.exports = __webpack_public_path__ + "static/media/Mareep_gaussian2.3dda43a8.png";